module.exports = __webpack_public_path__ + "img/uk.de151aee.png";